import Link from '@mui/material/Link'
import { Organization, TRANSLATE } from '../../types/organization'
import { Stack, Typography } from '@mui/material'

interface Props {
  pid?: string
  number?: string
  organization?: Organization
  stageId?: string
  year?: string
  description?: string
}

export default function ProcessTitle({
  pid = '0',
  number = '0',
  organization = Organization.AFAGHTEL,
  stageId,
  description = '',
  year = '',
}: Props) {
  return (
    <>
      <Stack
        direction="row"
        id="process-title"
        alignItems="center"
        sx={{ display: { xs: 'none', md: 'flex' } }}
      >
        <Link
          href={`/${pid}`}
          fontSize="larger"
          fontWeight="bold"
          color="text.light"
          underline="none"
        >
          {'بار شماره ' +
            (+number).toLocaleString('fa-IR') +
            ' - ' +
            TRANSLATE[organization]}
        </Link>
        <Typography fontSize="small" fontWeight="bold" sx={{ px: 2 }}>
          {'سال ' + (+year).toLocaleString('fa-IR', { useGrouping: false })}
        </Typography>
        {description && <Typography fontSize="smaller">({description})</Typography>}
      </Stack>

      <Stack direction="column" id="process-title" sx={{ display: { md: 'none' } }}>
        <Stack direction="row" alignItems="center" gap={1}>
          <Link
            href={`/${pid}`}
            fontSize="larger"
            fontWeight="bold"
            color="text.light"
            underline="none"
          >
            {TRANSLATE[organization] + ' - ' + (+number).toLocaleString('fa-IR')}
          </Link>
          <Typography fontSize="x-small">
            ( {'سال ' + (+year).toLocaleString('fa-IR', { useGrouping: false })})
          </Typography>
        </Stack>
        {description && <Typography fontSize="smaller">{description}</Typography>}
      </Stack>
    </>
  )
}
